<template>
  <div>
    <action-menu-wrapper :items="items" :offset="offset" teleport />

    <preset-modal
      v-if="showPresetModal"
      :close="() => (showPresetModal = false)"
      :preset-data="model"
      is-edit-mode
    />

    <confirm-modal
      v-if="showConfirmDeleteModal"
      :title="$t('PRESETS.DELETE_PRESET')"
      :description="$t('PRESETS.DELETE_WARNING', { preset: model.name })"
      confirm-button="Delete"
      confirm-button-type="error"
      :close="() => (showConfirmDeleteModal = false)"
      @confirm="deletePreset(model.id)"
    />
  </div>
</template>

<script setup lang="ts">
import { type PropType, ref } from "vue";
import { useI18n } from "vue-i18n";

import {
  useDeletePermissionPresetMutation,
  useDuplicatePermissionPresetMutation,
} from "@/hooks/queries/usePermissionsPresets";

import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import PresetModal from "@/components/presets/presetModal/PresetModal.vue";
import ActionMenuWrapper, {
  type MenuItem,
} from "@/components/ui/ActionMenuWrapperV2.vue";

import type { PermissionsPreset } from "@/models/permissionsPreset";

const props = defineProps({
  model: {
    type: Object as PropType<PermissionsPreset>,
    required: true,
  },
});

const offset = { left: -76, top: 43 };

const { t } = useI18n();

const { mutate: deletePreset } = useDeletePermissionPresetMutation();
const { mutate: duplicatePreset } = useDuplicatePermissionPresetMutation();

const showPresetModal = ref(false);
const showConfirmDeleteModal = ref(false);

const handleDuplicate = () => {
  duplicatePreset({
    ...props.model,
    assigned_client_ids: props.model.assigned_clients.map(
      (client) => client.id
    ),
  });
};

const items: MenuItem[] = [
  {
    label: t("COMMON.EDIT"),
    handler: () => (showPresetModal.value = true),
  },
  {
    label: t("COMMON.DUPLICATE"),
    handler: handleDuplicate,
  },
  {
    label: t("COMMON.DELETE"),
    handler: () => (showConfirmDeleteModal.value = true),
  },
];
</script>
